<template>
    <span v-if="file && file.id">
        <a href="javascript:" @click.prevent="downloadFile()">скачать</a>
    </span>
</template>

<script>
  import FileAPI from "../../modules/file/api";

  export default {
    name: "FileDownload",
    props: {
      file: Object
    },
    methods: {
      downloadFile() {
          var self = this;
        FileAPI.download(self.file.id)
          .then(response => {
              const blob = new Blob([response.data], { type: self.file.fileType });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.target = '_blank';
                link.download = self.file.originalName;
                link.click();
                URL.revokeObjectURL(link.href);
          });
      },
    }
  }
</script>

<style scoped>
</style>